// extracted by mini-css-extract-plugin
export var button = "CustomProjectGalleryCard-module--button--1532c";
export var content = "CustomProjectGalleryCard-module--content--4acf5";
export var contentLabels = "CustomProjectGalleryCard-module--contentLabels--4e858";
export var fadeInAnimation = "CustomProjectGalleryCard-module--fadeInAnimation--e63d9";
export var hint = "CustomProjectGalleryCard-module--hint--f4075";
export var hintLabel = "CustomProjectGalleryCard-module--hintLabel--b53da";
export var hintText = "CustomProjectGalleryCard-module--hintText--a5558";
export var imageLabels = "CustomProjectGalleryCard-module--imageLabels--af26e";
export var img = "CustomProjectGalleryCard-module--img--e34a9";
export var item = "CustomProjectGalleryCard-module--item--a86cd";
export var label = "CustomProjectGalleryCard-module--label--a0155";
export var lgWidth = "CustomProjectGalleryCard-module--lgWidth--aa1c6";
export var logo = "CustomProjectGalleryCard-module--logo--c534a";
export var logoWhite = "CustomProjectGalleryCard-module--logoWhite--3e855";
export var nda = "CustomProjectGalleryCard-module--nda--91aa8";
export var ndaIcon = "CustomProjectGalleryCard-module--ndaIcon--7c55e";
export var ndaLogoText = "CustomProjectGalleryCard-module--ndaLogoText--e2fd6";
export var picture = "CustomProjectGalleryCard-module--picture--dce88";
export var pictureWrapper = "CustomProjectGalleryCard-module--pictureWrapper--a6983";
export var title = "CustomProjectGalleryCard-module--title--3522d";